export default __webpack_public_path__ + "static/media/work-1.9128aff7.jpg";